import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import {Collapse, List, ListItemIcon} from "@mui/material";
import React from "react";
import {MenuContext} from "../AppMenu";
import StyledListItemButton from "./common/StyledListItemButton";
import StyledListItemText from "./common/StyledListItemText";

const AppMenuLinkContainer = ({ title, icon, children }) => {
  const { isMenuOpen, toggleIsMenuOpen } = React.useContext(MenuContext);
  const [isOpen, setIsOpen] = React.useState(false);

  const clickHandler = () => {
    if (!isMenuOpen) {
      toggleIsMenuOpen();
    } else {
      setIsOpen((oldIsOpen) => !oldIsOpen);
    }
  };

  React.useEffect(() => {
    if (!isMenuOpen) setIsOpen(false);
  }, [isMenuOpen]);

  return (
    <>
      <StyledListItemButton onClick={clickHandler}>
        {Boolean(icon) && (
          <ListItemIcon sx={{ color: "inherit" }}>
            {React.cloneElement(icon, { sx: { color: "inherit" } })}
          </ListItemIcon>
        )}

        <StyledListItemText primary={title} />
        {React.createElement(isOpen ? ExpandLess : ExpandMore, {
          sx: {
            opacity: isMenuOpen ? 1 : 0,
            transition: "opacity ease 300ms",
            color: "inherit !important",
          },
        })}
      </StyledListItemButton>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List component="div" sx={{ padding: 0 }}>
          {children}
        </List>
      </Collapse>
    </>
  );
};

export default AppMenuLinkContainer;
